namespace('arctic.views.gds');

compass.require('compass.hotel.StayRecapWidget');
compass.require('compass.hotel.EPSStayRecapWidget');
compass.require('compass.hotel.PoliciesWidget');
compass.require('compass.hotel.GDSPoliciesWidget');

compass.require('compass.demographic.PersonalInfoWidget');
compass.require('compass.demographic.CreditCardWidget');

compass.requireLib('compass.util.tracking');
compass.requireLib('compass.util.parse');

arctic.views.gds.gdsIndividualInfo = function (viewport, options) {
	// starts measuring the time it takes for the view to load
	compass.startLoad('gdsIndivdiualInfoView');

	var me = this;
	var $j = jQuery;
	var d = jQuery.dom.getContext(this);
	var _viewport = viewport;

	var _widgets = {};
	var _recapWidget;
	var _policiesWidget;
	var _paymentType = 'deposit';
	var _settings = options;
	var _currentReservation = {};
	var _gdsIndividualFormInvalid = false;
	var _form;

	var CC_CHARGE_HEADER = 'We need a credit card to hold your room.  NOTE: Your credit card will be charged a guarantee for this room at the time of booking.  Please review the hotel policies for additional information.';
	var CC_DEPOSIT_HEADER = 'We need a credit card to hold your room.  Please review the hotel policies for additional information regarding when your card may be charged.';
	var CC_EAN_FULL_PAYMENT_HEADER = 'Full payment is required to reserve your room. The card you provide will be charged today. Review the hotel policies for additional information.';
	var EPS_NO_DEPOSIT_HEADER = 'We need a credit card to hold your room.  You will pay the hotel directly for the cost of your stay.  Review the hotel policies for additional information.';
	var EPS_DEPOSIT_HEADER = 'A deposit is required to book your room.  Your card will be charged by the hotel.  Review the hotel policies for additional information.';
	var EPS_NON_REFUNDABLE_HEADER = 'This rate is non-refundable.  Your card will be charged by the hotel shortly after completing the booking.  Review the hotel policies for additional information.';

	var _drawTermsOfService = function(){
		if (_settings.meetingInfo.privacyPolicyLink.length === 0 ) return d.span({className: 'termsOfServiceText'}, '.');
		return [
				d.span({className: 'termsOfServiceText'}, ' and our '),
				d.a({className: 'termsOfServiceLink', 'href': _settings.meetingInfo.privacyPolicyLink, 'target': '_blank'}, 'terms of service.')
		];
	};
	
	
	var _render = function () {
		_form = d.form({ className: 'forms' },
					d.div({ className : 'personalInfoHeader'},
						d.div({ className : 'personalInfoTitle'}, 'Contact Details')
					),
					d.div({ className : 'personalInfoMain' }),
					d.div({ className : 'passwordsMain' }),
					d.div({ className : 'paymentHeader' },
						d.div({ className : 'paymentTitle'}, _settings.affiliate === 'EAN' ? 'Payment' : 'Payment Guarantee')
					),
					d.div({ className : 'creditCardTitle demographicTitle' }),
					d.div({ className : 'creditCardMain' }),
					d.div({ className : 'endPaymentInfo' }),
					d.div({className : 'policiesAgreeDiv'},
						d.input({className : 'policiesCheckbox',
							name: 'policiesCheckbox',
							'data-parsley-required': 'true',
							type: 'checkbox',
							value:'true'}),
						d.div({className :'policiesTextDiv'}, 'By placing your booking with us, you agree to the '),
						d.a({ className:'policiesLink'}, 'hotel policies'),
						d.div({ className : 'clear'}),
						_drawTermsOfService(),
						d.div({className: 'clear'})
					),
					d.button({ className : 'finishButton button', role : 'button' }, 'Finish')
				);

		_form.on('submit', function (evt) {
			evt.preventDefault();
			evt.stopPropagation();
			sendInfo();
		});

		_viewport.append(d.div({ className : 'personalInfo' },
			d.div({ className : 'individualFormsContainer'},
				d.div({ className : 'IndividualFormsWidget'},
					_form
				)
			),
			d.div({ className : 'stayRecapMain' }),
			d.div({ className : 'clear' })
		));
	};

	var _setup = function (data) {
		_currentReservation = data.reservations[0];

		var _isHotelCollect = _currentReservation.summary.merchant_of_record === "property";
		var _isEAN = _settings.affiliate === 'EAN';
		var _refundable = _currentReservation.summary.refundable === true;
		var _requiresDeposit = _currentReservation.summary.depositRequired === true;
		var _chargeToday = _paymentType === 'charge';
		var paymentHeader = '';

		// select correct payment header based on reservation status (affiliate, merchant of record, deposit status, refundability)
		if (_isEAN) {
			if (_isHotelCollect) {
				if (!_refundable) { paymentHeader = EPS_NON_REFUNDABLE_HEADER;
				} else {
					_requiresDeposit ? paymentHeader = EPS_DEPOSIT_HEADER : paymentHeader = EPS_NO_DEPOSIT_HEADER;
				}
			} else {
				paymentHeader = CC_EAN_FULL_PAYMENT_HEADER;
			}
		} else {
			_chargeToday ? paymentHeader = CC_CHARGE_HEADER : paymentHeader = CC_DEPOSIT_HEADER;
		}

		var paymentHeaderNode = document.createTextNode(paymentHeader);
		$j(".creditCardTitle").append(paymentHeaderNode);

		_widgets.personalInfo = new compass.demographic.PersonalInfoWidget(_viewport.find('.personalInfoMain'), {
			drawAddress: false,
			drawCompanyName : true,
			extraRequiredFields: data.extraRequiredFields,
			editablePrefill: _settings.regData,
			affiliate: _settings.affiliate
		});
		_widgets.password = new compass.demographic.PasswordWidget(_viewport.find('.passwordsMain'), {
		});

		_widgets.payment = new compass.demographic.PaymentWidget(_viewport.find('.creditCardMain'), {
			addressWidget: _settings.countriesAndStates,
			creditCardTypes: data.paymentOptions.payMethods,
			maskCCNumber : _.contains(data.extraRequiredFields, 'maskCreditCard'),
			minExpiration: compass.util.parse.ISODateParser(_settings.meetingInfo.ends),
			displayCVC: _currentReservation.summary.affiliate === 'EAN' ? true : false
		});

		if (_currentReservation.summary.affiliate === 'EAN') {
			compass.trackPageView('ExpediaIndividual');
			var displayProcessingCountry = data.reservations[0].summary.merchant_of_record === "expedia";
			_recapWidget = new compass.hotel.EPSStayRecapWidget(_viewport.find('.stayRecapMain'), {
				header: {
					hotelThumbnail: data.reservations[0].summary.hotelThumbnail,
					hotelName: data.reservations[0].summary.hotelName,
					roomType: data.reservations[0].summary.roomType,
					bedType: data.reservations[0].summary.bedType,
					bedRequest: data.reservations[0].summary.bedRequest,
					avgRate: data.reservations[0].summary.avgRate
				},
				recap: data.reservations[0].summary.recap,
				meetingInfo: _settings.meetingInfo,
				depositInfo: _settings.depositInfo,
				GDS: true,
				merchantOfRecord: data.reservations[0].summary.merchant_of_record,
				processingCountry: displayProcessingCountry ? data.processingCountry : ''
			});
			
			//Clicking Policy Link, specifically for EPS
			var _showEPSPoliciesPopup = function (data) {
				var dateFormatter = compass.util.dateFormatter('mmmm d, yyyy');
				
				var depositPolicyDone = false;
				var hotelPolicyDone = false;

				var depositPolicySuccess = false;
				var hotelPolicySuccess = false;

				var cancelPoliciesData = [];
				var depositPoliciesData = [];
				var hotelPoliciesData = {gdsHotelPolicies: {} };
				
				var displayDepositPolicy = data.reservations[0].summary.depositRequired;

				//Assembles policy dialogue after all ajax's have completed
				var waitForAllPolicies = function() {
					if (depositPolicyDone && hotelPolicyDone) {

						if (depositPolicySuccess && hotelPolicySuccess) {

							//Gather divs and send to policies widget
							var policiesDiv = d.div({className:'policiesContainer'});
						
							//Attach extra data to the policies object 
							if (cancelPoliciesData.length > 0) {
								hotelPoliciesData.gdsHotelPolicies.cancelPolicy = cancelPoliciesData;
							}
							if (depositPoliciesData.length > 0) {
								hotelPoliciesData.gdsHotelPolicies.depositPolicy = depositPoliciesData;
							}
							hotelPoliciesData.gdsHotelPolicies.roomName = data.reservations[0].summary.roomType;
							hotelPoliciesData.gdsHotelPolicies.refundable = data.reservations[0].summary.refundable;
							
							_policiesWidget = new compass.hotel.GDSPoliciesWidget(policiesDiv, {
								WUID: 'GDS_policiesWidget_individualinfo',
								policies: hotelPoliciesData,
								affiliateHandledByOurAgent: _settings.meetingInfo.affiliateHandledByOurAgent,
								phone: _settings.meetingInfo.phone
							});

							_policiesDialog = d.dialog({
								classes: 'hotelInfo policiesDialog',
								contents: policiesDiv,
								centerOnView: true
							});

						} else {
							var popupParams = {
								title: 'Sorry, there was a problem',
								message: 'Please click OK to try your request again.',
								triggerName: 'stayOnPage'
							};
							var errorMessage = d.div();
							var textPopupWidget = new compass.arctic.TextPopupWidget(errorMessage, popupParams);
							var textPopupWidgetDialog = d.dialog({
								classes: 'personalInfo testDialog',
								contents: errorMessage,
								centerOnView: true,
								showCloseButton: false
							});
							textPopupWidget.bind('stayOnPage', function () {
								textPopupWidgetDialog.close();
							});
						}

					}
				};

				//Format cancel penalties into strings
				if (data.reservations[0].summary.cancelPenalties !== undefined) {
					
					var cancelPenalties = data.reservations[0].summary.cancelPenalties;
					
					var formatDate = function(dateString){
						//Expects format of yyyy-mm-ddTnn:nn:nn.nnn-NN:NN, as provided by EPS
						var dateMoment = (moment(dateString).utcOffset(dateString));
						var formattedTime = dateMoment.format("h:mm A");
						var formattedDate = dateFormatter( compass.util.parse.ISODateParser( dateMoment.format("Y-MM-DD") ) );

						return {
							date: formattedDate,
							time: formattedTime
						};
					};
					
					//Dates will display as a range when there is more than one policy present
					var dateRange = (cancelPenalties.length > 1);
					
					for (var cancelIndex = 0; cancelIndex < cancelPenalties.length; cancelIndex++){
						var cancelObject = cancelPenalties[cancelIndex];
						
						//Format the displayed time
						var formattedStartDate = formatDate(cancelObject.start);
						var cancelStartDate = formattedStartDate.date;
						var cancelStartTime = formattedStartDate.time;
						if (dateRange === true) {
							var formattedEndDate = formatDate(cancelObject.end);
							var cancelEndDate = formattedEndDate.date;
							var cancelEndTime = formattedEndDate.time;
						}
						
						//Find the penalty value
						var cancelPrice = '';
						if (cancelObject.amount !== undefined) {
							cancelPrice += ' a ' + cancelObject.amount + cancelObject.currency + ' property fee';
						}
						if (cancelObject.nights !== undefined){
							if (cancelPrice !== '') {
								cancelPrice += ', and';
							}
							cancelPrice += " " + cancelObject.nights + ' night(s) rate, plus taxes and fees';
						} 
						if (cancelObject.percent !== undefined){
							if (cancelPrice !== '') {
								cancelPrice += ', and';
							}
							cancelPrice += " " + (cancelObject.percent) + " of the total cost of the reservation";
						}
						
						var cancelLine = "";
						// If there is more than one cancel policy present, display as a range
						if (dateRange === true){ 
							cancelLine = "Cancellations or changes made between " + cancelStartTime
								+ " (hotel's local time) on " + cancelStartDate + " and " + cancelEndTime
								+ " (hotel's local time) on " + cancelEndDate + ", or no-shows will be charged " + cancelPrice + ".";
							} else { //...otherwise, display as a single date
								cancelLine = "Cancellations or changes made after " + cancelStartTime + " (hotel's local time) on "
									+ cancelStartDate + ", or no-shows will be charged" +  cancelPrice + ".";
						}
						cancelPoliciesData.push(cancelLine);
					}
				}
				
				//Ajax for Hotel Policies
				jQuery.ajax({
					data: { hotel_id: data.reservations[0].summary.hotel_id },
					dataType:'json',
					traditional: true,
					url:'/getGDSHotelPolicies',
					success : function(data) {
						hotelPoliciesData = data;

						if (!(data.gdsHotelPolicies.error)) {
							hotelPolicySuccess = true;
						}
					},
					complete : function() {
						hotelPolicyDone = true;
						waitForAllPolicies();
					}
				});

				if (displayDepositPolicy) {
					for (var depositCount=0; depositCount < data.reservations[0].summary.deposits.length; depositCount++) {
						var depositObject = data.reservations[0].summary.deposits[depositCount];
						var depositDate = dateFormatter( compass.util.parse.ISODateParser(depositObject.due));
						var depositPrice = depositObject.value + ' ' + depositObject.currency;
						var depositLine = "You will be charged a deposit of " + depositPrice + " on " + depositDate + ' by the property.';
						depositPoliciesData.push(depositLine);
					}
				}
				depositPolicyDone = true;
				depositPolicySuccess = true;
				waitForAllPolicies();
			};
			_viewport.find('.policyLink').click(function(e) {
				e.preventDefault();
				_showEPSPoliciesPopup(data);
			});
			_viewport.find('.policiesLink').activate(function(e) {
				e.preventDefault();
				_showEPSPoliciesPopup(data);
			});
		} else {
			compass.trackPageView('GdsIndividual');
			_recapWidget = new compass.hotel.StayRecapWidget(_viewport.find('.stayRecapMain'), {
				recapArray: [data.reservations[0].summary],
				meetingInfo: _settings.meetingInfo,
				GDS: true
			});
			_viewport.find('.policiesLink').activate(function () { _showPoliciesPopup(data); });
		}

		_viewport.find(".stayRecapMain").bind('StayRecapWidget.showPolicies', function () {_showPoliciesPopup(data); });

		_viewport.find('.policiesCheckbox').change(function() {
			if ($(this).is(':checked')) {
				$('.alertCloseButton').activate();
			}
		});
	};

	var _addValidation = function() {
		_form.parsley({
			aria: true,
			errorClass: 'invalid',
			errorsContainer: function (elem) {
				elem = elem.$element;
				var $container = elem.next();

				if ($container.hasClass('reqHint')) {
					return $container;
				}

				var $container = d.div({ className: 'reqHint' });
				$container.append(d.div({ className: 'triangle' }));

				elem.after($container);

				elem.one('focus', function (evt) {
					$container.css({ "left": (elem.outerWidth(true)-$container.outerWidth(true))/2 + elem.position().left });
				});

				return $container;
			},
			errorsWrapper: '<div class=\'text\'></div>',
			errorTemplate: '<span></span>'
		});

		_form.parsley().on('form:error', function() {
 			_gdsIndividualFormInvalid = true;
 			return;
 		});

		_form.parsley().on('field:validate', function(elem) {
			return !$(elem).is(":visible") || $(elem).hasClass('placeholder');
		});

		_form.parsley().on('field:success', function(elem) {
			if (_gdsIndividualFormInvalid) {
				if (_form.find('.invalid').length < 1) {
					_gdsIndividualFormInvalid = false;
					var button = _form.find('.finishButton');
					button.removeClass('disabled').attr('tabindex', '0');
				}
			}
		});
	};

	var _showPoliciesPopup = function (data) {
		var policiesStruct = {
			policies:{
			"depositPolicy" : data.reservations[0].GDSInfo.GDSDepositPolicy,
			"cancelPolicy" : data.reservations[0].GDSInfo.GDSCancelPolicy,
			"changesPolicy" : "",
			"specialPolicy" : "",
			"roomName" : data.reservations[0].summary.roomType,
			"hotelName" : data.reservations[0].summary.hotelName
		}};

		var policiesDiv = d.div({className:'policiesContainer'});

		_policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv, {
			policies: policiesStruct
		});

		_policiesDialog = d.dialog({
			classes: 'personalInfo policiesDialog',
			contents: policiesDiv,
			centerOnView: true
		});

	};

	var sendInfo = function (event) {
		var button = _viewport.find('.finishButton');
		var data = {};
		if(button.hasClass('disabled')) { return; }
		button.addClass('disabled');

		data.policiesCheckbox = $j('.policiesCheckbox').prop('checked');
		if(data.policiesCheckbox === false){
			_policiesAgreeDialog = d.alert('Please agree to the hotel policies before continuing');
		}

		_form.parsley().validate();

		if(!_form.parsley().isValid()){
			_groupMememberFormInvalid = true;
 			return;
		}

		data.contact = _widgets.personalInfo.grabValues();
		data.payment = _widgets.payment.grabValues();
		data.password = _widgets.password.grabValues();
		data.affiliate = _settings.affiliate;
		
		if(data.affiliate === 'EAN') {
			data.epsBookingURI = _jsonData.reservations[0].summary.links.book.href;
			var countryCode = _.findWhere( _jsonData.countriesAndStates.countries, { name: data.payment.address.country } );
			data.payment.address.countryCode = countryCode ? countryCode.abbrv : 'US';
			data.payment.paid = _jsonData.reservations[0].summary.totalCost;
			
			var expireYear = parseInt(data.payment.expYear);
			var expireMonth = parseInt(data.payment.expMonth) - 1;
			data.payment.expireISODate = (new Date(expireYear, expireMonth)).toISOString();
			
			data.handled_by_our_agent = _settings.meetingInfo.affiliateHandledByOurAgent;

			compass.loading.start(button.empty(), { color : '#FFFFFF' });
		}
		
		function _stopButtonLoad() {
			compass.loading.stop();
			button.empty().append('Finish');
		}
		
		$j.ajax({
			url: '/actEPSIndividualInfo',
			data : JSON.stringify(data),
			type : 'POST',
			contentType : 'application/json',
			processData: false,
			timeout: 90000,
			error: function (data) {
				button.prop("disabled", false);
				_stopButtonLoad();
				var popupParams = {
							title: 'Sorry, there was a problem',
							message: 'Please click OK to try your booking again.',
							triggerName: 'returnFromGDSIndividualInfo'
						};
						var errorMessage = d.div();
						var textPopupWidget = new compass.arctic.TextPopupWidget(errorMessage, popupParams);
						var textPopupWidgetDialog = d.dialog({
							classes: 'personalInfo testDialog',
							contents: errorMessage,
							centerOnView: true,
							showCloseButton: false
						});
						textPopupWidget.bind('returnFromGDSIndividualInfo', function () {
							_viewport.trigger(CompassEvents.Navigate, 'hotelInfo/' + _settings.hotel_id);

						});
			},
			success: function (data) {
				_stopButtonLoad();

				if(data.GDSSuccess === true){
					var estimatedTotal = _recapWidget.getEstimatedTotalValue();
					jQuery.ajax({
					url : '/sendConfirmation',
						success : function(data) {
							compass.util.tracking.exactTargetConversion();
							compass.util.tracking.googleConversion({
								value: estimatedTotal,
								currency: _settings.meetingInfo.currencyCode
							});
						}
					});
					// Keen Tracking
					compass.trackEvent('ReservationCreated', {
						"iterations": _settings.iterations,
						"reservations": {
							"blocked_room_id": _currentReservation.blocked_room_id,
							"arrive": _currentReservation.arrive,
							"depart": _currentReservation.depart,
							"rooms": _currentReservation.rooms
						}
					});
					compass.GA.trackEvent('CompassDirect', 'ReservationCreated');
					$j('body').css({cursor : 'inherit'});
					$j('body').trigger(CompassEvents.Login, data.loginInfo);
					_viewport.trigger(CompassEvents.Navigate, 'frontDesk');
				}
				else{
					if (data.affiliate === 'EAN') {
						var popupParams = {
							title: data.error.errorTitle,
							message: data.error.errorText,
							triggerName: 'returnFromGDSIndividualInfo'
						};
						var errorMessage = d.div();
						var textPopupWidget = new compass.arctic.TextPopupWidget(errorMessage, popupParams);
						var textPopupWidgetDialog = d.dialog({
							classes: 'personalInfo testDialog',
							contents: errorMessage,
							centerOnView: true
						});
						textPopupWidget.bind('returnFromGDSIndividualInfo', function () {
							if(data.error.errorType === 'invalid_input') {
								button.removeClass('disabled');
								textPopupWidgetDialog.close();
							} else {
								_viewport.trigger(CompassEvents.Navigate, 'hotelInfo/' + _settings.hotel_id);
							}
						});
						$(".closeButtonDefault").css('display','none');
					}
					else if (data.policiesCheckboxChecked === false) {
						d.alert("Please agree to the hotel policies before continuing.");
					} else {
						d.alert(data.error.errorText).find('.alertCloseButton').activate(function(){
							$j('body').trigger(CompassEvents.Login, data.loginInfo);
							_viewport.trigger(CompassEvents.Navigate, 'search');
						});
					}
				}
			}
		});
	};

	this.run = function (renderComplete) {
		compass.loading.start();
		$j.ajax({
			url: '/getGDSIndividualInfo',
			//url: '/personalInfo',
			success: function (data) {
				_jsonData = data;
				_settings.iterations = data.iterations || 1;
				_settings.countriesAndStates = data.countriesAndStates;
				_settings.affiliate = data.reservations[0].summary.affiliate;
				_settings.hotel_id = data.reservations[0].summary.hotel_id;
				_settings.processingCountry = data.processingCountry;
				_settings.depositInfo = {
					'depositRequired': data.reservations[0].summary.depositRequired,
					'refundable': data.reservations[0].summary.refundable
				};
				if (data.error) {
					_viewport.trigger(CompassEvents.Navigate, 'frontdesk');
				} else {
					_render();
					_setup(data);
					_addValidation();
				}
				compass.loading.stop();
				// stops measuring the time it takes the view to load
				compass.stopLoad('gdsIndivdiualInfoView');
				renderComplete();
			}
		});
	};
};